import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    DataTableActions: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '.5rem',
    },
    DataTableActionButtonDanger: {
        borderColor: `${defaultPalette.error.main} !important`,
    },
})
